import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from './App'
import './styles.css'

// React 18 + StrictMode enabled. The rubber-band multi-select now uses a callback
// ref that handles React 18's strict-mode double-invocation by cleaning up the
// previous listener before re-binding. (@dnd-kit handles its own StrictMode safety.)
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
